import { createContext, useContext } from "react";
import { WorkspaceUserPermissions } from "@zappar/zw-api-client";

const ModeContext = createContext<{ premium: boolean; isToolMode: boolean; useNestleFeatures: boolean; permissions: WorkspaceUserPermissions['zml'] | undefined }>({ premium: false, isToolMode: false, useNestleFeatures: false, permissions: undefined });

export const useMode = () => useContext(ModeContext);

export const ModeProvider = ({ children, premium, isToolMode, useNestleFeatures, permissions }: { children: React.ReactNode; premium: boolean; isToolMode: boolean; useNestleFeatures: boolean; permissions: WorkspaceUserPermissions['zml'] | undefined }) => {
  return <ModeContext.Provider value={{ premium, isToolMode, useNestleFeatures, permissions }}>{children}</ModeContext.Provider>;
};
